import { createApp } from 'vue'
import { install } from 'vue3-recaptcha-v2'
import App from './App.vue'
import router from './router'
import ElementPlus from './plugins/element'
import i18n from './plugins/i18n'
import store from './store/store'
import VueFeatherPlugin from './plugins/vueFeather'
import ElementIconsPlugin from './plugins/elementIcons'
import VueVirtualScroller from 'vue3-virtual-scroller'
import '@hotelkeyrepo/hk-ui-toolkit-vue-3/dist/style.css';
import '@hotelkeyrepo/hk-ui-toolkit-vue-3/src/assets/global.css'
import 'normalize.css/normalize.css'
import '@/assets/style/main.scss'
import '@/common/polyfills'
import 'vue3-virtual-scroller/dist/vue3-virtual-scroller.css'
import { createPinia } from 'pinia';
import { loadAppDynamics, attachAdrumScript } from '@hotelkeyrepo/hk-ui-utilities-vue-3/src/common/services/utilities.service';
import { enforceReloginOnBrowserClose } from '@hotelkeyrepo/hk-ui-utilities-vue-3/src/common/services/browserCloseGuard';
import { Buffer } from 'buffer'
import deepClone from 'clone';
import '@hotelkeyrepo/hk-trainkey-vue-3/src/trainkey/init';
import '@hotelkeyrepo/hk-trainkey-vue-3/src/trainkey/plugins/flowy-vue/dist/lib/style.css';
import vtooltip from "@hotelkeyrepo/hk-trainkey-vue-3/src/trainkey/directives/v-training/v-tooltip"
import { installA11yDirectives } from "vue-a11y-directives";
// add buffer in global window
window.Buffer = Buffer

// EA-94073: after a full browser close, leave for SSO relogin. hk-home reads
// the config flag directly. On the logout route itself the guard stays
// disabled so that flow isn't re-triggered.
const forceReloginOnBrowserClose = window.hkConfigEnvs?.VUE_APP_FORCE_RELOGIN_ON_BROWSER_CLOSE === 'true'

// Mirror for the satellite apps, which have no config key of their own. Written
// here rather than in Home.vue so every hk-home page load refreshes it: after
// an environment flips the flag, a user who never lands on the Home screen
// would otherwise keep the stale value and the guard would stay off.
localStorage.setItem('force_relogin_on_browser_close', forceReloginOnBrowserClose)

const onLogoutRoute = window.location.hash.includes('/logout') || window.location.pathname.endsWith('/logout')
const reloginCheck = enforceReloginOnBrowserClose({
  enabled: !onLogoutRoute && forceReloginOnBrowserClose
})


const app = createApp(App)
const pinia = createPinia();
app.directive("hotelkey-tip", vtooltip);
installA11yDirectives(app);

// const isProduction = window.hkConfigEnvs.NODE_ENV === 'production'


app.use(pinia);
app.use(install)
app.use(router)
app.use(ElementPlus)
app.use(i18n)
app.use(VueVirtualScroller)
app.use(store)
app.use(VueFeatherPlugin)
app.use(ElementIconsPlugin)
app.config.globalProperties.$deepClone = deepClone;

// EA-94073: wait for the guard before mounting so Home.vue can't start the
// shared worker first. Unlike the satellite apps, hk-home mounts even when the
// guard fired: its logout() only sets the hash to #/logout, and the router
// guard is what actually runs that flow — by then the route is already
// #/logout, so Home.vue (and its worker init) never mounts.
reloginCheck.finally(() => {
    app.mount('#app')

    //adrum
    // Prefer Dynatrace when configured: skip AppDynamics if VUE_APP_DYNATRACE_URL is set
    // (both instrument Promise -> "Maximum call stack size exceeded").
    if(window.hkConfigEnvs.VUE_APP_DYNAMICS_KEY && !window.hkConfigEnvs.VUE_APP_DYNATRACE_URL){
        loadAppDynamics({appDynamicsKey: window.hkConfigEnvs.VUE_APP_DYNAMICS_KEY})
        attachAdrumScript()
    }
})

